const addAssigment = (localRedux, value) => ({ type: localRedux, state: value });
export default addAssigment;